module.exports = __webpack_public_path__ + "img/20180815_151629_179.90ae2b9f.jpg";